import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue, set, push, get, remove, update } from "firebase/database";
import {
  getFirestore,
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  query,
  where,
  orderBy,
  limit,
  serverTimestamp,
  arrayUnion,
  arrayRemove,
  writeBatch
} from "firebase/firestore";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  sendPasswordResetEmail
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCJ9UWDFIcDnVbDfz10nJ_kksHgH6dLCBM",
  authDomain: "tempsensor-d0f96.firebaseapp.com",
  databaseURL: "https://tempsensor-d0f96-default-rtdb.firebaseio.com",
  projectId: "tempsensor-d0f96",
  storageBucket: "tempsensor-d0f96.firebasestorage.app",
  messagingSenderId: "700851315698",
  appId: "1:700851315698:web:f2b152d6f9d27dc122c16b",
  measurementId: "G-98JJVCJB1H"
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const db = getFirestore(app);
const auth = getAuth(app);

export {
  // Config
  firebaseConfig,
  // Realtime Database (legacy)
  database,
  ref,
  onValue,
  set,
  push,
  get,
  remove,
  update,
  // Firestore
  db,
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  query,
  where,
  orderBy,
  limit,
  serverTimestamp,
  arrayUnion,
  arrayRemove,
  writeBatch,
  // Auth
  auth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  sendPasswordResetEmail
};
